import { COLLECTION_PAGE_BY_KIND } from "../constants";
import { StorefrontCollectionKind } from "../types";

export const urls = {
  storefrontCollection: (slug: string, kind: StorefrontCollectionKind) =>
    `/api/client/v1/catalog/${COLLECTION_PAGE_BY_KIND[kind].path}/${encodeURIComponent(slug)}/`,
};

export const keys = {
  all: () => ["product-collections"],
  detail: (slug: string, kind: StorefrontCollectionKind) => [...keys.all(), "detail", kind, slug],
};
